<template>
  <div class="website_container">
    <div class="website_content clearfix">
      <!-- <div class="website_content_left"> -->
        <img style="width: 100%;" :src="contentImg" alt="content" />
        <!-- <div class="topicBox" v-on:mouseover="_stopScroll()" v-on:mouseout="_moveScroll()">
          <div class="caroufredsel_wrapper">
            <transition-group tag="ul" class="clearfix" id="topicList" :name="animationName">
              <li
                class="img-list-li"
                v-for="(item,index) in imgList"
                v-show="index == imgIndex"
                :key="item.title"
              >
                <img :src="item.link" :alt="item.title" />
              </li>
            </transition-group>
          </div>
          <div class="clearfix"></div>
          <a
            id="topic_prev"
            class="prev"
            href="javascript:void(0);"
            style="display: block;"
            @click="toggleImgIndex('prev')"
          ></a>
          <a
            id="topic_next"
            class="next"
            href="javascript:void(0);"
            style="display: block;"
            @click="toggleImgIndex('next')"
          ></a>
          <div id="topic_pager" class="topicPager" style="display: block;">
            <a
              v-bind:key="index"
              href="javascript:;"
              v-for="(item, index) in imgList"
              :class="{selected: index === imgIndex}"
              @click="toggleImgIndex(index)"
            >
              <span>{index + 1}</span>
            </a>
          </div>
        </div> -->
        <!-- <Carousel
          :animationName="animationName"
          title="猜你喜欢"
          :page="likeRadioPage"
          :musicList="likeRadioList"
          @togglePage="_togglePage(...arguments, 'like')"
          @showSign="$emit('toggle-show', true)"
          @play="gotoPlay"
        ></Carousel> -->
        <!-- <Carousel
          :animationName="animationName"
          title="热榜"
          :page="hotRadioPage"
          :musicList="hotRadioList"
          @togglePage="_togglePage(...arguments, 'hot')"
          @showSign="$emit('toggle-show', true)"
          @play="gotoPlay"
        ></Carousel>
         -->
      <!-- </div> -->
      <!-- <div class="website_content_right right">
        <a
          rel="nofollow"
          href="javascript:;"
          class="recommend_img"
          @mouseenter="showPlayBtn=true"
          @mouseleave="showPlayBtn=false"
          @click.stop="gotoPlay(recommend)"
        >
          <img :src="recommend.coverUrl" alt="今日推荐" style="width:250px;" />
          <span class="play_btn" v-if="showPlayBtn"></span>
        </a>
        <div class="recommend">今日推荐</div>
        <div class="riseList_container">
          <div class="riseList_header clearfix">
            <span class="left">飙升榜</span>
            <a href="javascript:;" class="right" @click="$emit('toggle-show', true)">查看全部</a>
          </div>
          <ul class="riseList_list">
            <li
              class="riseList_item clearfix"
              v-for="(item) in riseRadioList"
              :key="item.id"
              @click.stop="gotoPlay(item)"
            >
              <img :src="item.coverUrl" :alt="item.name" class="riseList_item_avatar left" />
              <div class="riseList_item_summary left">
                <p class="riseList_item_summary_title">{{ item.name }}</p>
                <p class="riseList_item_summary_author">{{ item.singer }}</p>
              </div>
              <span class="riseList_item_time right" v-if="item.duration">{{ item.duration }}</span>
              <span class="riseList_item_time right" v-else>- - : - -</span>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import config from "../../configCenter.json";
// import Carousel from "@/components/carousel";
let banner1 = require("@/assets/banner1.jpg");
let banner2 = require("@/assets/banner2.jpg");
let banner3 = require("@/assets/banner3.jpg");
let banner4 = require("@/assets/banner4.png");
let contentImg = require("@/assets/content.png");

export default {
  data() {
    return {
      config,
      imgIndex: 0,
      imgList: [
        {
          title: "虽然看不见这个世界，但萧煌奇制造的阳光让我们无法自拔",
          link: banner1,
        },
        {
          title: "来自格陵兰的高冷情书，张洪量",
          link: banner2,
        },
        {
          title: "如果我们不曾相遇，五月天",
          link: banner3,
        },
        {
          title: "我好像在哪见过你，薛之谦",
          link: banner4,
        },
      ],
      styleList: ["摇滚", "民谣", "纯音乐", "电音", "翻唱", "流行"],
      animationName: "right",
      timeInterval: 3000,
      likeRadioPage: 0,
      likeRadioList: [],
      hotRadioPage: 0,
      hotRadioList: [],
      riseRadioList: [],
      recommend: [],
      durationArr: [233, 228, 239, 242, 221],
      showPlayBtn: false,
      contentImg,
    };
  },
  created() {
    console.log('Website组件已创建');
    this._playScroll();
    // 直接使用虚拟数据，不请求接口
    this._loadDefaultData();
    console.log('虚拟数据加载完成');
    console.log('likeRadioList:', this.likeRadioList);
    console.log('hotRadioList:', this.hotRadioList);
    console.log('riseRadioList:', this.riseRadioList);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  mounted() {
    document.title = config.title || config.companyFullName
  },
  components: {
    // Carousel,
    
  },
  methods: {
    gotoPlay(music) {
      this.$router.push({
        path: "/play",
        query: { music },
      });
    },
    toggleImgIndex(index) {
      if (typeof index === "number") {
        if (this.imgIndex > index) {
          this.animationName = "left";
        } else {
          this.animationName = "right";
        }
        this.imgIndex = index;
      } else {
        if (index === "prev") {
          this.animationName = "left";
          this.imgIndex !== 0 ? --this.imgIndex : (this.imgIndex = 3);
        } else {
          this.animationName = "right";
          this.imgIndex !== 3 ? ++this.imgIndex : (this.imgIndex = 0);
        }
      }
    },
    _togglePage(page, str) {
      if (page === 0) {
        this.animationName = "left";
      } else {
        this.animationName = "right";
      }
      if (str === "like") {
        this.likeRadioPage = page;
      } else if (str === "hot") {
        this.hotRadioPage = page;
      }
    },
    _play() {
      this.animationName = "right";
      this.imgIndex++;
      if (this.imgIndex === this.imgList.length) {
        this.imgIndex = 0;
      }
    },
    // 开始滚动
    _playScroll() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
      this.timer = window.setInterval(this._play, this.timeInterval);
    },
    // 停止滚动 当鼠标移入
    _stopScroll() {
      clearInterval(this.timer);
      this.timer = null;
    },
    // 开始继续滚动 当鼠标移出
    _moveScroll() {
      this._playScroll();
    },
    _getCurrentTime(list) {
      let i = list.length;
      while (i--) {
        let item = list[i];
        item.duration = this._formatTime(this.durationArr[i]);
      }
    },
    _formatList(list) {
      let rtn = [],
        arr = [];
      for (let i = 0; i < list.length; i++) {
        arr.push(list[i]);
        if ((i + 1) % 4 === 0) {
          rtn.push(arr);
          arr = [];
        }
      }
      return rtn;
    },
    _formatTime(ts) {
      let time = Math.floor(ts);
      let min = Math.floor(time / 60);
      let sec = Math.floor(time % 60);
      min = min < 10 ? `0${min}` : min;
      sec = sec < 10 ? `0${sec}` : sec;
      return `${min}:${sec}`;
    },
    _loadDefaultData() {
      console.log('加载虚拟数据...');
      
      // 创建丰富的虚拟音乐数据 - 使用不知名的歌曲
      const virtualMusicData = [
        { name: "小巷深处", singer: "阿木", coverUrl: banner1 },
        { name: "雨夜独行", singer: "小凡", coverUrl: banner2 },
        { name: "街角咖啡", singer: "梦梦", coverUrl: banner3 },
        { name: "深夜电台", singer: "小强", coverUrl: banner4 },
        { name: "城市边缘", singer: "阿华", coverUrl: banner1 },
        { name: "星空物语", singer: "小美", coverUrl: banner2 },
        { name: "时光印记", singer: "阿杰", coverUrl: banner3 },
        { name: "青春日记", singer: "小雅", coverUrl: banner4 },
        { name: "远方来信", singer: "阿明", coverUrl: banner1 },
        { name: "午后阳光", singer: "小丽", coverUrl: banner2 },
        { name: "城市夜景", singer: "阿强", coverUrl: banner3 },
        { name: "青春纪念册", singer: "小婷", coverUrl: banner4 },
        { name: "微风轻抚", singer: "阿伟", coverUrl: banner1 },
        { name: "时光荏苒", singer: "小芳", coverUrl: banner2 },
        { name: "街角故事", singer: "阿斌", coverUrl: banner3 },
        { name: "星空之约", singer: "小玲", coverUrl: banner4 },
      ];
      
      // 创建热榜数据 - 使用不知名的歌曲
      const hotMusicData = [
        { name: "夜雨纷飞", singer: "小刚", coverUrl: banner1 },
        { name: "青春无悔", singer: "阿珍", coverUrl: banner2 },
        { name: "午后咖啡", singer: "小军", coverUrl: banner3 },
        { name: "城市夜曲", singer: "阿红", coverUrl: banner4 },
        { name: "青春岁月", singer: "小波", coverUrl: banner1 },
        { name: "时光印记", singer: "阿兰", coverUrl: banner2 },
        { name: "街角回忆", singer: "小勇", coverUrl: banner3 },
        { name: "星空之约", singer: "阿青", coverUrl: banner4 },
        { name: "午后阳光", singer: "小燕", coverUrl: banner1 },
        { name: "城市故事", singer: "阿峰", coverUrl: banner2 },
        { name: "青春纪念", singer: "小梅", coverUrl: banner3 },
        { name: "时光倒流", singer: "阿龙", coverUrl: banner4 },
        { name: "街角时光", singer: "小慧", coverUrl: banner1 },
        { name: "星空漫步", singer: "阿虎", coverUrl: banner2 },
        { name: "午后时光", singer: "小萍", coverUrl: banner3 },
        { name: "城市漫步", singer: "阿豹", coverUrl: banner4 },
      ];
      
      this.likeRadioList = this._formatList(virtualMusicData);
      this.hotRadioList = this._formatList(hotMusicData);
      
      // 飙升榜数据 - 使用不知名的歌曲
      this.riseRadioList = [
        { id: 1, name: "小巷深处", singer: "阿木", coverUrl: banner1, duration: "04:16" },
        { id: 2, name: "雨夜独行", singer: "小凡", coverUrl: banner2, duration: "05:26" },
        { id: 3, name: "街角咖啡", singer: "梦梦", coverUrl: banner3, duration: "04:58" },
        { id: 4, name: "深夜电台", singer: "小强", coverUrl: banner4, duration: "04:38" },
        { id: 5, name: "城市边缘", singer: "阿华", coverUrl: banner1, duration: "04:24" },
        { id: 6, name: "星空物语", singer: "小美", coverUrl: banner2, duration: "04:20" },
        { id: 7, name: "时光印记", singer: "阿杰", coverUrl: banner3, duration: "04:32" },
        { id: 8, name: "青春日记", singer: "小雅", coverUrl: banner4, duration: "04:18" },
      ];
      
      this._getCurrentTime(this.riseRadioList);
      this.recommend = { 
        coverUrl: banner1, 
        name: "今日推荐：小巷深处", 
        singer: "阿木",
        id: 999
      };
    }
  },
};
</script>

<style lang="less" scoped>
@import "index";
</style>
